import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import {
  SG_LOGIN_UPDATE_ACCOUNT_DEFAULT,
} from "constants/actions";

import { Domain } from "../_config.js";

import UserErrorMessages from "./UserErrorMessages";

// shadcn ui
import { Button } from "../components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "../components/ui/card";
import { Label } from "../components/ui/label";
import {
  Select as UISelect,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Alert, AlertDescription, AlertTitle } from "../components/ui/alert";

// icons
import { AlertCircle, Building2, Loader2, LogOut } from "lucide-react";



const SelectOrg = ({ userInputRequired = false, loginCheck = false, props }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [email, setEmail] = useState("")

  const [orgList, setOrgList] = useState([])
  const [selectedOrg, setSelectedOrg] = useState(false)

  const [formErrors, setFormErrors] = useState([]);
  const [pristine, setPristine] = useState(true);

  const [userAuth, setUserAuth] = useState(false)
  const [pending, setPending] = useState(false)
  const [toPath, setToPath] = useState(false)


  const { get_auth } = useSelector(
    (state) => ({
      get_auth: state.auth
    }),
    shallowEqual
  );

  useEffect(() => {
    setUserAuth(get_auth)
    setOrgList(get_auth?.organization_list)
    setEmail(get_auth?.user?.email)
    setPending(get_auth?.pending)
  }, [get_auth]);


  useEffect(() => {
    if (!get_auth?.token) {
      return navigate("/account/login");
    }

  }, [navigate, get_auth]);



  // const [loginInput, setLoginInput] = useState(true)
  const [userInput, setUserInput] = useState(true)
  const [checkForStaff, setCheckForStaff] = useState(false);
  const IsStaff = useSelector((state) => state.auth?.is_staff, shallowEqual)

  useEffect(() => {
    if (typeof IsStaff == "boolean") {
      // variable is a boolean
      if (IsStaff) {
        setCheckForStaff(true)
      }
      // console.log("IsStaff Boolean")
    }
    if (typeof IsStaff == "string") {
      // variable is a boolean
      if (IsStaff === 'true') {
        setCheckForStaff(true)
      }
      // console.log("IsStaff string")
    }

  }, [IsStaff]);
  // console.log(NavList)
  // useEffect(() => {
  //   const timer1 = setTimeout(() => {
  //     if (!checkForStaff) {
  //       return navigate('/app/no-access')

  //     }
  //   }, 2000);
  //   return () => clearTimeout(timer1);
  // }, [checkForStaff, navigate]);

  useEffect(() => {
    setUserInput(userInputRequired)
  }, [userInputRequired]);

  // useEffect(() => {
  //   setLoginInput(loginCheck)
  // }, [loginCheck]);

  useEffect(() => {
    const ErrorList = [];
    let totalErrors = 0
 
      if (orgList?.length > 0) {
        if (!selectedOrg?.AccountID) {
          ErrorList["organization"] =
          {
            error: true,
            message: "Please select an Organization"
          };
          totalErrors += 1
        }
      }
      if (toPath?.pathname === "/app/no-access") {
        ErrorList["organization"] =
        {
          error: true,
          message: `Please select a Organization which is not ${selectedOrg?.Name} (${selectedOrg.OrganizationID}) where you are the staff, only staff members can login`
        };
        totalErrors += 1
      }
      ErrorList['errors'] = totalErrors
      setFormErrors(ErrorList);
    
  }, [
    orgList, selectedOrg, pristine, toPath, userInput
  ]);


  const onSubmit = () => {
    if (formErrors?.errors > 0) {
      setPristine(false);
      return;
    }

    dispatch({
      type: SG_LOGIN_UPDATE_ACCOUNT_DEFAULT,
      payload: {
        email: email,
        account_id: selectedOrg?.AccountID,
        employee_id: selectedOrg?.EmployeeID,
      },
    });

    setPristine(true);
    setUserInput(false)
    setToPath(false)
  };




  if (pending) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="flex items-center gap-3 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span>Loading…</span>
        </div>
      </div>
    );
  }



  let { from } = props?.location?.state || {
    from: { pathname: "/app/dashboard" },
  }; // new

  // if both the tokens are same send show the dashboard
  if (get_auth?.token?.trim() === get_auth?.account_default?.verify_token?.trim() && !userInput) {
    return <Navigate to={from} />;
  }

  function Logout() {
    navigate("/account/logout")
 }

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4">
      <div className="w-full max-w-xl">
        <Card>
          <CardHeader className="space-y-2">
            <div className="flex items-center gap-3">
              <img src={Domain.image} alt="Logo" className="h-10 w-auto" />
              <CardTitle className="text-xl">Select an Organization</CardTitle>
            </div>
            {email ? (
              <CardDescription className="flex items-center gap-2">
                <Building2 className="h-4 w-4" /> Signed in as {email}
              </CardDescription>
            ) : null}
          </CardHeader>
          <CardContent className="space-y-4">
            <UserErrorMessages />

            {formErrors?.organization?.error && !pristine && (
              <Alert variant="destructive">
                <AlertCircle className="h-4 w-4" />
                <AlertTitle>We need these details</AlertTitle>
                <AlertDescription>
                  {formErrors?.organization?.message}
                </AlertDescription>
              </Alert>
            )}

            <div className="space-y-2">
              <Label htmlFor="organization">Organization</Label>
              <UISelect
                value={selectedOrg ? String(selectedOrg.OrganizationID) : ""}
                onValueChange={(value) => {
                  const found = orgList?.find(
                    (o) => String(o?.OrganizationID) === String(value)
                  );
                  setSelectedOrg(found || false);
                }}
              >
                <SelectTrigger id="organization" className="w-full">
                  <SelectValue placeholder="Select an organization" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Organizations</SelectLabel>
                    {orgList?.map((option) => (
                      <SelectItem
                        key={option.OrganizationID}
                        value={String(option.OrganizationID)}
                      >
                        {`${option.Name} (${option.OrganizationID})`}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </UISelect>
            </div>
          </CardContent>
          <CardFooter className="flex items-center justify-between gap-3">
            <Button variant="ghost" type="button" onClick={Logout} className="gap-2">
              <LogOut className="h-4 w-4" /> Logout
            </Button>
            <Button onClick={onSubmit} id="sign-in" className="gap-2">
              Continue
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default SelectOrg;